if (!customElements.get('b2b-quantity-input')) {
  class B2BQuantityInput extends HTMLElement {
    constructor() {
      super();
      this.minus = this.querySelector('.minus');
      this.plus = this.querySelector('.plus');
      this.input = this.querySelector('.general-quantity__input');
      this.outerProductsPerBoxInput = this.closest('.b2b-product-card').querySelector(
        'input[name="quantity"].b2b-quantity-form-input'
      );
      this.outerProductsPerBoxInput.value = this.outerProductsPerBoxInput.value.trim();
      this.originalValue = this.outerProductsPerBoxInput.value;
    }

    connectedCallback() {
      this.plus.addEventListener('click', (e) => this.changeQuantity(e));
      this.minus.addEventListener('click', (e) => this.changeQuantity(e, true));
    }

    changeQuantity = (e, minus = false) => {
      e.preventDefault();
      if (minus) {
        this.input.value = Math.max(1, parseInt(this.input.value) - 1);
      } else {
        this.input.value = parseInt(this.input.value) + 1;
      }
      this.outerProductsPerBoxInput.value = this.originalValue * this.input.value;
    };
  }
  customElements.define('b2b-quantity-input', B2BQuantityInput);
}
